import SamaritanFetch from './httpClient';

export const fetchCareCoordinatorReferrals = (params: {
    homelessId?: number;
    refereeId?: number;
    referrerId?: number;
}) => {
    let url = '/care_coordinator_referrals';
    const queryParams = [];

    if (params.homelessId) {
        queryParams.push(`care_coordinator_referrals[homeless_id]=${params.homelessId}`);
    }
    if (params.refereeId) {
        queryParams.push(`care_coordinator_referrals[referee_id]=${params.refereeId}`);
    }
    if (params.referrerId) {
        queryParams.push(`care_coordinator_referrals[referrer_id]=${params.referrerId}`);
    }

    if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
    }

    return SamaritanFetch.v3(url, {
        method: 'GET'
    });
}; 